import { render, staticRenderFns } from "./table-item.vue?vue&type=template&id=0cdd63ae&scoped=true&"
import script from "./table-item.vue?vue&type=script&lang=js&"
export * from "./table-item.vue?vue&type=script&lang=js&"
import style0 from "./table-item.vue?vue&type=style&index=0&id=0cdd63ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdd63ae",
  null
  
)

export default component.exports